import { FETCH_DATA_FAILURE, FETCH_DATA_REQUEST, FETCH_DATA_SUCCESS, CLEAR_DATA_REQUEST } from "./actionTypes";

// List of API endpoints
const apiEndpoints = [
  'topFiveProduct',
  'modelDetails',
  'feedbackDetails',
  'policySignDetails',
  'userThreadDetails',
  'renameUserDetails',
  'deleteUserDetails',
];

// Dynamically generate the initial state
const initialState = apiEndpoints.reduce((state, endpoint) => {
  state[endpoint] = {
    data: [],
    loading: false,
    error: null,
  };
  return state;
}, {});

const apiReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DATA_REQUEST:
      return {
        ...state,
        [action.api]: {
          ...(state[action.api] || { data: [], loading: false, error: null }),
          loading: true,
          error: null,
        },
      };

    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        [action.api]: {
          data: action.payload || [],
          loading: false,
          error: null,
        },
      };

    case FETCH_DATA_FAILURE:
      return {
        ...state,
        [action.api]: {
          ...(state[action.api] || { data: [], loading: false, error: null }),
          loading: false,
          error: action.payload,
        },
      };

      case CLEAR_DATA_REQUEST:
        return {
          ...state,
          // uploadFile: { data: null, loading: false, error: null },
        };

    default:
      return state;
  }
};

export default apiReducer;